import { BaseComponent } from "utils/base-component"

import "./webcam-suggestion-form.scss"

export class WebcamSuggestionForm extends BaseComponent {
  static cssClass = "webcam-suggestion-form"

  init() {
    const form = this.element("form")?.element
    const toggle = this.root.querySelector('[data-role="toggle"]')

    if (this.root.dataset.scrollOnLoad === "true") {
      this.scrollToForm()
    }

    if (!toggle || !form) return

    toggle.addEventListener("click", (event) => {
      event.preventDefault()
      form.classList.remove(this.elementClassName("form--hidden"))
      const cta = toggle.closest(`.${this.elementClassName("cta")}`)
      if (cta) cta.remove()
      const firstInput = form.querySelector("input[type=text]")
      if (firstInput) firstInput.focus()
    })
  }

  scrollToForm() {
    window.requestAnimationFrame(() => {
      const top = window.pageYOffset + this.root.getBoundingClientRect().top
      window.scrollTo(0, Math.max(top, 0))
    })
  }
}
